import { imagePropsSchema } from '../component-catalog.js';
export const imageDefinition = {
    type: 'Image',
    category: 'content',
    propsSchema: imagePropsSchema,
    isDataBacked: false,
    needsMeasuredDims: true,
    defaultMinHeight: 100,
    description: 'Inline image by URL. Props: src (required), alt?, fit? ("contain" | "cover" | "fill" | "none").',
};
//# sourceMappingURL=Image.js.map